
import { Row, Col, Input, Form, Button, List } from 'antd'
import StationNameSearch from 'containers/common/StationNameSearch'

import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import '../confirmDialog.css'
import './CompareDialog.css'

function EditProjectDialog({ show, onSubmit, handleCancel, stations, project, isBPIDClear }) {

    const [selectedStation, setSelectedStation] = useState(project.stationName)
    const [form] = Form.useForm();

    const onFinish = (formData) => {
        onSubmit(formData)
    }

    const handleStationChange = (station) => {
        setSelectedStation(station);
        form.setFieldsValue({ stationName: station })
    }
    useEffect(() => {
        if (project) {
            form.setFieldsValue({ bpid: isBPIDClear?'':project.bpid, stationName: project.stationName, workOrder: project.workOrder, removalWO: project.removalWO, removalBPID: project.removalBPID })
        }
    }, [isBPIDClear])


    return (
        <>
            <Modal className='centered-title-modal' show={show} onHide={handleCancel} size="lg" centered >

                <Modal.Header closeButton style={{ display: 'block' }} >
                    Please edit the information below
                </Modal.Header>
                <Form
                    form={form}
                    labelCol={{
                        span: 10,
                    }}
                    wrapperCol={{
                        span: 14,
                    }}
                    style={{ padding: '1rem 1rem' }}
                    onFinish={onFinish}

                >
                    <div style={{ top: 15, position: 'relative' }}>
                        <Row>
                            <Col span={24}>
                                <Form.Item
                                    labelCol={{ xxl: { span: 6 }, lg: { span: 6 }, sm: { span: 10 }, xs: { span: 10 }, md: { span: 10 } }}
                                    label="IPS Station Name:"
                                    name="stationName"
                                    className='form-input-custom-label'
                                    rules={[{ required: true, message: 'Station Name is required.' }]}
                                >

                                    <StationNameSearch
                                        stations={stations}
                                        handleChange={handleStationChange}
                                        defaultValue={selectedStation}
                                        style={{ height: 40, display: 'flex', alignItems: 'center', overflow: 'hidden' }}
                                    />
                                </Form.Item>

                            </Col>

                        </Row>
                        <Row>
                            <Col
                                xs={{
                                    span: 24,
                                }}
                                sm={{
                                    span: 24,
                                }}
                                md={{
                                    span: 24,
                                }}
                                lg={{
                                    span: 12,
                                }}
                                xxl={{
                                    span: 12,
                                }}>
                                <Form.Item
                                    label="BPID"
                                    name="bpid"
                                    className='form-input-custom-label'
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter new BPID!',
                                        },
                                    ]}
                                >
                                    <Input className='custom-input-width' />
                                </Form.Item>
                            </Col>
                            <Col
                                xs={{
                                    span: 24,
                                }}
                                sm={{
                                    span: 24,
                                }}
                                md={{
                                    span: 24,
                                }}
                                lg={{
                                    span: 12,
                                }}
                                xxl={{
                                    span: 12,
                                }}
                            >
                                <Form.Item
                                    label="Removal BPID"
                                    name="removalBPID"
                                    className='form-input-custom-label'
                                >
                                    <Input className='custom-input-width' />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col
                                xs={{
                                    span: 24,
                                }}
                                sm={{
                                    span: 24,
                                }}
                                md={{
                                    span: 24,
                                }}
                                lg={{
                                    span: 12,
                                }}
                                xxl={{
                                    span: 12,
                                }}
                            >
                                <Form.Item
                                    label="Work Order"
                                    name="workOrder"
                                    className='form-input-custom-label'
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please enter new Work Order!',
                                        },
                                    ]}
                                >
                                    <Input className='custom-input-width' />
                                </Form.Item>
                            </Col>
                            <Col
                                xs={{
                                    span: 24,
                                }}
                                sm={{
                                    span: 24,
                                }}
                                md={{
                                    span: 24,
                                }}
                                lg={{
                                    span: 12,
                                }}
                                xxl={{
                                    span: 12,
                                }}>
                                <Form.Item
                                    label="Removal WO"
                                    name="removalWO"
                                    className='form-input-custom-label'
                                >
                                    <Input className='custom-input-width' />
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-centered-content" >
                        <Button type='primary' id="cancelButton" htmlType="submit">Save</Button>
                        <Button type='primary' id="cancelButton" onClick={handleCancel}>Cancel</Button>
                    </div>


                </Form>

            </Modal>
        </>
    )
}

export default EditProjectDialog;            